import { polylines } from './index'

const getPolylineByFromId = id => {
  let polyline = {}

  for (let i = 0; i < polylines.length; i++) {
    if(polylines[i].fromId === id)
      polyline = polylines[i]
  }

  return polyline
}

export default getPolylineByFromId



// WEBPACK FOOTER //
// ./app/polylines/getPolylineByFromId.js